import { SubscriptionTier } from '../services/organizationService'

/**
 * Safely extracts the display name from subscriptionTier
 * Handles both legacy string format (production) and new object format (dev environment)
 *
 * @param subscriptionTier - Can be string (legacy), SubscriptionTier object (new), null, or undefined
 * @returns Display name string or 'N/A' if unavailable
 *
 * @example
 * // Legacy format (production)
 * getSubscriptionTierDisplayName("premium") // Returns: "premium"
 *
 * @example
 * // New format (dev)
 * getSubscriptionTierDisplayName({ tierDisplayName: "Premium Plan", ... }) // Returns: "Premium Plan"
 */
export function getSubscriptionTierDisplayName(
  subscriptionTier: string | SubscriptionTier | undefined | null
): string {
  if (!subscriptionTier) return 'N/A'

  // Handle legacy string format (production)
  if (typeof subscriptionTier === 'string') {
    return subscriptionTier
  }

  // Handle new object format (dev)
  return subscriptionTier.tierDisplayName || subscriptionTier.tierName || 'Unknown'
}

/**
 * Safely extracts the tier name from subscriptionTier
 * Handles both legacy string format and new object format
 *
 * @param subscriptionTier - Can be string (legacy), SubscriptionTier object (new), null, or undefined
 * @returns Tier name string or 'N/A' if unavailable
 *
 * @example
 * // Legacy format
 * getSubscriptionTierName("premium") // Returns: "premium"
 *
 * @example
 * // New format
 * getSubscriptionTierName({ tierName: "premium", ... }) // Returns: "premium"
 */
export function getSubscriptionTierName(
  subscriptionTier: string | SubscriptionTier | undefined | null
): string {
  if (!subscriptionTier) return 'N/A'

  if (typeof subscriptionTier === 'string') {
    return subscriptionTier
  }

  return subscriptionTier.tierName || 'Unknown'
}
